import {INTERNAL_ADMIN, INTERNAL_ALL_ROLES, INTERNAL_DEVELOPER} from '../../core/services/roles/roles';

export type NodeObjectType = 'menu' | 'action' | 'chathub' | 'error' | 'integration' | 'start';

const canvasBasePath = '/assets/svg/redesign/nodes/canvas-icons/';
const gitBookBasePath = 'https://clickatell.gitbook.io/flow/';

export interface NodeTypes {
    menuNodes: NodeObject[];
    actionNodes: NodeObject[];
    integrationsNodes: IntegrationsNodes;
    startNodes: NodeObject[];
    chathubNodes: NodeObject[];
}

export interface Canvas {
    icon: string;
    backgroundImg: string;
    backgroundImgHover: string;
    backgroundImgSelected: string;
}

export interface Image {
    primary: string;
    fallback?: string;
}


export enum NodeSupportedChannels {
    APPLE = 'apple',
    WHATSAPP = 'whatsapp',
    ALL = 'all',
}

export interface NodeObject {
    supported_channel: NodeSupportedChannels;
    canvas?: Canvas;
    count: number;
    description: string;
    image: Image;
    nodeInfoSrc: string;
    sortType: string;
    nodeType: string;
    type: NodeObjectType;
    extraFields?: {};
    title: string;
    show?: boolean;
    canvasIcon?: string;
    permissions?: {
        canEdit: string[],
    };
}

export interface IntegrationsNodes {
    FUNDING_SOURCE: NodeObject[];
    VENDOR: NodeObject[];
    default: NodeObject[];
}

export const chat2payNodeObject: NodeObject = {
    supported_channel: NodeSupportedChannels.ALL,
    canvas: {
        icon: canvasBasePath + 'chat2pay.svg',
        backgroundImg: '/assets/svg/redesign/nodes/commerce-nodes.svg',
        backgroundImgHover: '/assets/svg/redesign/nodes/commerce-nodes-hover.svg',
        backgroundImgSelected: '/assets/svg/redesign/nodes/commerce-nodes-selected.svg',
    },
    count: 0,
    description: 'Enable end-users to make secure payments using Chat 2 Pay',
    image: {
        primary: '/assets/svg/redesign/nodes/right-panel/chat2pay.svg',
    },
    nodeInfoSrc: gitBookBasePath + 'user-facing-nodes/commerce/chat-2-pay',
    sortType: 'Commerce',
    nodeType: 'chat2pay',
    title: 'Chat 2 Pay',
    type: 'menu',
};


const menuNodeObjects: NodeObject[] = [
    {
        supported_channel: NodeSupportedChannels.ALL,
        canvas: {
            icon: canvasBasePath + 'contactReceiving.svg',
            backgroundImg: '/assets/svg/redesign/nodes/input-nodes.svg',
            backgroundImgHover: '/assets/svg/redesign/nodes/input-nodes-hover.svg',
            backgroundImgSelected: '/assets/svg/redesign/nodes/input-nodes-selected.svg',
        },
        count: 0,
        description: 'Request a contact from an end-user',
        image: {
            primary: '/assets/svg/redesign/nodes/right-panel/contactReceiving.svg',
        },
        nodeInfoSrc: gitBookBasePath + 'user-facing-nodes/input-nodes/contact-receiving',
        sortType: 'Input',
        title: 'Contact Receiving',
        nodeType: 'contactReceiving',
        type: 'menu',
    },
    {
        supported_channel: NodeSupportedChannels.ALL,
        canvas: {
            icon: canvasBasePath + 'askInput.svg',
            backgroundImg: '/assets/svg/redesign/nodes/input-nodes.svg',
            backgroundImgHover: '/assets/svg/redesign/nodes/input-nodes-hover.svg',
            backgroundImgSelected: '/assets/svg/redesign/nodes/input-nodes-selected.svg',
        },
        count: 0,
        description: 'Request input from an end-user',
        image: {
            primary: '/assets/svg/redesign/nodes/right-panel/askInput.svg',
        },
        nodeInfoSrc: gitBookBasePath + 'user-facing-nodes/input-nodes/menu-nodes-ask-for-input',
        sortType: 'Input',
        title: 'Request Input',
        nodeType: 'askInput',
        type: 'menu',
    },
    {
        supported_channel: NodeSupportedChannels.ALL,
        canvas: {
            icon: canvasBasePath + 'dynamicList.svg',
            backgroundImg: '/assets/svg/redesign/nodes/logic-nodes.svg',
            backgroundImgHover: '/assets/svg/redesign/nodes/logic-nodes-hover.svg',
            backgroundImgSelected: '/assets/svg/redesign/nodes/logic-nodes-selected.svg',
        },
        count: 0,
        description: 'Personalize your list for each end-user',
        image: {
            primary: '/assets/svg/redesign/nodes/right-panel/dynamicList.svg',
        },
        nodeInfoSrc: gitBookBasePath + 'user-facing-nodes/branch-logic-split/menu-nodes-dynamic-list',
        sortType: 'Logic',
        title: 'Dynamic List',
        nodeType: 'dynamicList',
        type: 'menu',
    },
    {
        supported_channel: NodeSupportedChannels.ALL,
        canvas: {
            icon: canvasBasePath + 'displayMenu.svg',
            backgroundImg: '/assets/svg/redesign/nodes/display-nodes.svg',
            backgroundImgHover: '/assets/svg/redesign/nodes/display-nodes-hover.svg',
            backgroundImgSelected: '/assets/svg/redesign/nodes/display-nodes-selected.svg',

        },
        count: 0,
        description: 'Display a message to end-users at the end of a flow',
        image: {
            primary: '/assets/svg/redesign/nodes/right-panel/displayMenu.svg',
        },
        nodeInfoSrc: gitBookBasePath + 'user-facing-nodes/display-nodes/text-display',
        sortType: 'Display',
        nodeType: 'displayMenu',
        title: 'Text Display',
        type: 'menu',
    },
    {
        supported_channel: NodeSupportedChannels.ALL,
        canvas: {
            icon: canvasBasePath + 'menuOption.svg',
            backgroundImg: '/assets/svg/redesign/nodes/logic-nodes.svg',
            backgroundImgHover: '/assets/svg/redesign/nodes/logic-nodes-hover.svg',
            backgroundImgSelected: '/assets/svg/redesign/nodes/logic-nodes-selected.svg',
        },
        count: 0,
        description: 'Main menu to route end-users to flows',
        image: {
            primary: '/assets/svg/redesign/nodes/right-panel/menuOption.svg',
        },
        nodeInfoSrc: gitBookBasePath + 'user-facing-nodes/branch-logic-split/menu-nodes-menu-with-options',
        sortType: 'Logic',
        nodeType: 'menuOption',
        title: 'Menu',
        type: 'menu',
    },
    {
        supported_channel: NodeSupportedChannels.ALL,
        canvas: {
            icon: canvasBasePath + 'multipleChoice.svg',
            backgroundImg: '/assets/svg/redesign/nodes/logic-nodes.svg',
            backgroundImgHover: '/assets/svg/redesign/nodes/logic-nodes-hover.svg',
            backgroundImgSelected: '/assets/svg/redesign/nodes/logic-nodes-selected.svg',
        },
        count: 0,
        description: 'Present end-users with various options to select from',
        image: {
            primary: '/assets/svg/redesign/nodes/right-panel/multipleChoice.svg',
        },
        nodeInfoSrc: gitBookBasePath + 'user-facing-nodes/branch-logic-split/menu-nodes-multiple-choice-input',
        sortType: 'Logic',
        nodeType: 'multipleChoice',
        title: 'Multiple Choice Input',
        type: 'menu',
    },
    {
        supported_channel: NodeSupportedChannels.ALL,
        canvas: {
            icon: canvasBasePath + 'externalLink.svg',
            backgroundImg: '/assets/svg/redesign/nodes/display-nodes.svg',
            backgroundImgHover: '/assets/svg/redesign/nodes/display-nodes-hover.svg',
            backgroundImgSelected: '/assets/svg/redesign/nodes/display-nodes-selected.svg',
        },
        count: 0,
        description: 'Provide your end-user with a URL to an external website',
        image: {
            primary: '/assets/svg/redesign/nodes/right-panel/externalLink.svg',
        },
        nodeInfoSrc: gitBookBasePath + 'user-facing-nodes/display-nodes/menu-nodes-external-link',
        sortType: 'Display',
        nodeType: 'externalLink',
        title: 'External Link',
        type: 'menu',
    },
    {
        supported_channel: NodeSupportedChannels.ALL,
        canvas: {
            icon: canvasBasePath + 'contactSending.svg',
            backgroundImg: '/assets/svg/redesign/nodes/input-contact-nodes.svg',
            backgroundImgHover: '/assets/svg/redesign/nodes/input-contact-nodes-hover.svg',
            backgroundImgSelected: '/assets/svg/redesign/nodes/input-contact-nodes-selected.svg',
        },
        count: 0,
        description: 'Send a contact card to an end-user',
        image: {
            primary: '/assets/svg/redesign/nodes/right-panel/contactSending.svg',
        },
        nodeInfoSrc: gitBookBasePath + 'user-facing-nodes/display-nodes/menu-nodes-contact-sending',
        sortType: 'Display',
        nodeType: 'contactSending',
        title: 'Contact Sending',
        type: 'menu',
    },
    {
        supported_channel: NodeSupportedChannels.ALL,
        canvas: {
            icon: canvasBasePath + 'chatdesk.svg',
            backgroundImg: '/assets/svg/redesign/nodes/product-nodes.svg',
            backgroundImgHover: '/assets/svg/redesign/nodes/product-nodes-hover.svg',
            backgroundImgSelected: '/assets/svg/redesign/nodes/product-nodes-selected.svg',
        },
        count: 0,
        description: 'Connect to Chat desk and enable live agent engagement',
        image: {
            primary: '/assets/svg/redesign/nodes/right-panel/chatdesk.svg',
        },
        nodeInfoSrc: gitBookBasePath + 'user-facing-nodes/product-nodes/chat-desk-node',
        sortType: 'Products',
        nodeType: 'chatdesk',
        title: 'Chat Desk',
        type: 'menu',
    },
    {
        supported_channel: NodeSupportedChannels.ALL,
        canvas: {
            icon: canvasBasePath + 'media.svg',
            backgroundImg: '/assets/svg/redesign/nodes/display-nodes.svg',
            backgroundImgHover: '/assets/svg/redesign/nodes/display-nodes-hover.svg',
            backgroundImgSelected: '/assets/svg/redesign/nodes/display-nodes-selected.svg',
        },
        count: 0,
        description: 'Enable media support within your flows (inbound and outbound media sharing)',
        image: {
            primary: '/assets/svg/redesign/nodes/right-panel/media.svg',
        },
        nodeInfoSrc: gitBookBasePath + 'user-facing-nodes/display-nodes/user-facing-interactions-media-node',
        sortType: 'Display',
        nodeType: 'media',
        title: 'Media Node',
        type: 'menu',
    },
    {
        supported_channel: NodeSupportedChannels.ALL,
        canvas: {
            icon: canvasBasePath + 'richLink.svg',
            backgroundImg: '/assets/svg/redesign/nodes/display-nodes.svg',
            backgroundImgHover: '/assets/svg/redesign/nodes/display-nodes-hover.svg',
            backgroundImgSelected: '/assets/svg/redesign/nodes/display-nodes-selected.svg',
        },
        count: 0,
        description: 'Provide your end-user with a URL to an external website',
        image: {
            primary: '/assets/svg/redesign/nodes/right-panel/richLink.svg',
        },
        nodeInfoSrc: gitBookBasePath + 'user-facing-nodes/display-nodes/rich-link',
        title: 'Rich Link',
        sortType: 'Display',
        nodeType: 'richLink',
        type: 'menu',
    },
    {
        supported_channel: NodeSupportedChannels.ALL,
        canvas: {
            icon: canvasBasePath + 'location.svg',
            backgroundImg: '/assets/svg/redesign/nodes/display-nodes.svg',
            backgroundImgHover: '/assets/svg/redesign/nodes/display-nodes-hover.svg',
            backgroundImgSelected: '/assets/svg/redesign/nodes/display-nodes-selected.svg',
        },
        count: 0,
        description: 'Enable location sharing within your flows (send or receive location pin)',
        image: {
            primary: '/assets/svg/redesign/nodes/right-panel/location.svg',
        },
        nodeInfoSrc: gitBookBasePath + 'user-facing-nodes/display-nodes/location-sharing',
        sortType: 'Display',
        title: 'Location Sharing',
        nodeType: 'location',
        type: 'menu',
    },
    {
        supported_channel: NodeSupportedChannels.APPLE,
        canvas: {
            icon: canvasBasePath + 'timePicker.svg',
            backgroundImg: '/assets/svg/redesign/nodes/input-nodes.svg',
            backgroundImgHover: '/assets/svg/redesign/nodes/input-nodes-hover.svg',
            backgroundImgSelected: '/assets/svg/redesign/nodes/input-nodes-selected.svg',
        },
        count: 0,
        description: 'Provide your end-user to sign in',
        image: {
            primary: '/assets/svg/redesign/nodes/right-panel/timePicker.svg',
        },
        nodeInfoSrc: gitBookBasePath + 'user-facing-nodes/input-nodes/time-picker',
        sortType: 'Input',
        nodeType: 'timePicker',
        title: 'Time Picker',
        type: 'menu',
    },
    {
        supported_channel: NodeSupportedChannels.ALL,
        canvas: {
            icon: canvasBasePath + 'otp.svg',
            backgroundImg: '/assets/svg/redesign/nodes/display-nodes.svg',
            backgroundImgHover: '/assets/svg/redesign/nodes/display-nodes-hover.svg',
            backgroundImgSelected: '/assets/svg/redesign/nodes/display-nodes-selected.svg',
        },
        count: 0,
        description: 'Send a one-time pin via SMS to verify the end-user',
        image: {
            primary: '/assets/svg/redesign/nodes/right-panel/otp.svg',
        },
        nodeInfoSrc: gitBookBasePath + 'user-facing-nodes/display-nodes/otp-menu',
        sortType: 'Display',
        title: 'OTP Menu',
        nodeType: 'otp',
        type: 'menu',
    },
    {
        supported_channel: NodeSupportedChannels.APPLE,
        canvas: {
            icon: canvasBasePath + 'orca_payment.svg',
            backgroundImg: '/assets/svg/redesign/nodes/commerce-nodes.svg',
            backgroundImgHover: '/assets/svg/redesign/nodes/commerce-nodes-hover.svg',
            backgroundImgSelected: '/assets/svg/redesign/nodes/commerce-nodes-selected.svg',
        },
        count: 0,
        description: 'Enable end-users to make secure payments using a debit/credit card',
        image: {
            primary: '/assets/svg/redesign/nodes/right-panel/orca_payment.svg',
        },
        nodeInfoSrc: gitBookBasePath + '',
        sortType: 'Commerce',
        title: 'Apple Payment',
        nodeType: 'orca_payment',
        type: 'menu',
    },
    {
        supported_channel: NodeSupportedChannels.ALL,
        canvas: {
            icon: canvasBasePath + 'authenticate.svg',
            backgroundImg: '/assets/svg/redesign/nodes/input-nodes.svg',
            backgroundImgHover: '/assets/svg/redesign/nodes/input-nodes-hover.svg',
            backgroundImgSelected: '/assets/svg/redesign/nodes/input-nodes-selected.svg',
        },
        count: 0,
        description: 'Trigger an authentication request as part of your workflow',
        image: {
            primary: '/assets/svg/redesign/nodes/right-panel/authenticate.svg',
        },
        nodeInfoSrc: gitBookBasePath + 'user-facing-nodes/input-nodes/oauth-request',
        sortType: 'Input',
        nodeType: 'authenticate',
        title: 'OAUTH Request',
        type: 'menu',
    },
    {
        supported_channel: NodeSupportedChannels.APPLE,
        canvas: {
            icon: canvasBasePath + 'iMessage.svg',
            backgroundImg: '/assets/svg/redesign/nodes/input-nodes.svg',
            backgroundImgHover: '/assets/svg/redesign/nodes/input-nodes-hover.svg',
            backgroundImgSelected: '/assets/svg/redesign/nodes/input-nodes-selected.svg',
        },
        count: 0,
        description: 'Provide your end-user to sign in',
        image: {
            primary: '/assets/svg/redesign/nodes/right-panel/iMessage.svg',
        },
        nodeInfoSrc: gitBookBasePath + '',
        sortType: 'Input',
        nodeType: 'iMessage',
        title: 'iMessage',
        type: 'menu',
    },
    {
        supported_channel: NodeSupportedChannels.APPLE,
        canvas: {
            icon: canvasBasePath + 'Forms.svg',
            backgroundImg: '/assets/svg/redesign/nodes/input-nodes.svg',
            backgroundImgHover: '/assets/svg/redesign/nodes/input-nodes-hover.svg',
            backgroundImgSelected: '/assets/svg/redesign/nodes/input-nodes-selected.svg',
        },
        canvasIcon: '/assets/svg/redesign/nodes/right-panel/Forms.svg',
        count: 0,
        description: 'Apple Business Forms',
        image: {
            primary: '/assets/svg/redesign/nodes/right-panel/Forms.svg',
        },
        nodeInfoSrc: gitBookBasePath + 'user-facing-nodes/input-nodes/send-form',
        sortType: 'Input',
        title: 'Send Form',
        nodeType: 'menuForm',
        type: 'menu',
    },
    {
        supported_channel: NodeSupportedChannels.ALL,
        canvas: {
            icon: canvasBasePath + 'chat2pay.svg',
            backgroundImg: '/assets/svg/redesign/nodes/commerce-nodes.svg',
            backgroundImgHover: '/assets/svg/redesign/nodes/commerce-nodes-hover.svg',
            backgroundImgSelected: '/assets/svg/redesign/nodes/commerce-nodes-selected.svg',
        },
        canvasIcon: '/assets/svg/redesign/nodes/right-panel/chat2pay.svg',
        count: 0,
        description: 'Enable end-users to make secure payments using Chat 2 Pay',
        image: {
            primary: '/assets/svg/redesign/nodes/right-panel/chat2pay.svg',
        },
        nodeInfoSrc: gitBookBasePath + 'user-facing-nodes/commerce/chat-2-pay',
        sortType: 'Commerce',
        nodeType: 'chat2pay',
        title: 'Chat 2 Pay',
        type: 'menu',
    },
];

export const multiProductNode: NodeObject = {
    supported_channel: NodeSupportedChannels.WHATSAPP,
    canvas: {
        icon: canvasBasePath + 'multiProduct.svg',
        backgroundImg: '/assets/svg/redesign/nodes/input-nodes.svg',
        backgroundImgHover: '/assets/svg/redesign/nodes/input-nodes-hover.svg',
        backgroundImgSelected: '/assets/svg/redesign/nodes/input-nodes-selected.svg',
    },
    count: 0,
    description: 'Send a list of products from a catalogue to an end-user',
    image: {
        primary: '/assets/svg/redesign/nodes/right-panel/multiProduct.svg',
    },
    nodeInfoSrc: gitBookBasePath + 'user-facing-nodes/commerce/multiple-product',
    sortType: 'Commerce',
    nodeType: 'multiProduct',
    title: 'Multi Product',
    type: 'menu',
};

export const aiAssistantNode: NodeObject = {
    supported_channel: NodeSupportedChannels.ALL,
    canvas: {
        icon: canvasBasePath + 'OmniAIAssistantNode.svg',
        backgroundImg: '/assets/svg/redesign/nodes/product-nodes.svg',
        backgroundImgHover: '/assets/svg/redesign/nodes/product-nodes-hover.svg',
        backgroundImgSelected: '/assets/svg/redesign/nodes/product-nodes-selected.svg',

    },
    count: 0,
    description: 'Choose an AI assistant to use for automated interactions.',
    image: {
        primary: '/assets/svg/redesign/nodes/right-panel/aiAssistant.svg',
    },
    nodeInfoSrc: gitBookBasePath + 'user-facing-nodes/display-nodes/text-display',
    sortType: 'Products',
    nodeType: 'aiAssistant',
    title: 'Clickatell AI',
    type: 'menu',
};

const actionNodeObjects: NodeObject[] = [
    {
        supported_channel: NodeSupportedChannels.ALL,
        canvas: {
            icon: canvasBasePath + 'dateFormat.svg',
            backgroundImg: '/assets/svg/redesign/nodes/action-nodes.svg',
            backgroundImgHover: '/assets/svg/redesign/nodes/action-nodes-hover.svg',
            backgroundImgSelected: '/assets/svg/redesign/nodes/action-nodes-selected.svg',
        },
        count: 0,
        description: 'Format date inputs to a specified date format',
        image: {
            primary: '/assets/svg/redesign/nodes/right-panel/dateFormat.svg',
        },
        nodeInfoSrc: gitBookBasePath + 'action-nodes/action-nodes-date-format',
        sortType: '',
        nodeType: 'dateFormat',
        title: 'Date Format',
        type: 'action',
    },
    {
        supported_channel: NodeSupportedChannels.ALL,
        canvas: {
            icon: canvasBasePath + 'displayList.svg',
            backgroundImg: '/assets/svg/redesign/nodes/action-nodes.svg',
            backgroundImgHover: '/assets/svg/redesign/nodes/action-nodes-hover.svg',
            backgroundImgSelected: '/assets/svg/redesign/nodes/action-nodes-selected.svg',
        },
        count: 0,
        description: 'Display a dynamic list retrieved from a HTTP call',
        image: {
            primary: '/assets/svg/redesign/nodes/right-panel/displayList.svg',
        },
        nodeInfoSrc: gitBookBasePath + 'action-nodes/action-nodes-display-list',
        sortType: '',
        nodeType: 'displayList',
        title: 'Display List',
        type: 'action',
    },
    {
        supported_channel: NodeSupportedChannels.ALL,
        canvas: {
            icon: canvasBasePath + 'encrypt.svg',
            backgroundImg: '/assets/svg/redesign/nodes/action-nodes.svg',
            backgroundImgHover: '/assets/svg/redesign/nodes/action-nodes-hover.svg',
            backgroundImgSelected: '/assets/svg/redesign/nodes/action-nodes-selected.svg',
        },
        count: 0,
        description: 'Encrypt variables to be used in other actions',
        image: {
            primary: '/assets/svg/redesign/nodes/right-panel/encrypt.svg',
        },
        nodeInfoSrc: gitBookBasePath + 'action-nodes/action-nodes-encrypt',
        sortType: '',
        nodeType: 'encrypt',
        title: 'Encrypt',
        type: 'action',
    },
    {
        supported_channel: NodeSupportedChannels.ALL,
        canvas: {
            icon: canvasBasePath + 'httpCall.svg',
            backgroundImg: '/assets/svg/redesign/nodes/action-nodes.svg',
            backgroundImgHover: '/assets/svg/redesign/nodes/action-nodes-hover.svg',
            backgroundImgSelected: '/assets/svg/redesign/nodes/action-nodes-selected.svg',
        },
        count: 0,
        description: 'Connect to external API endpoints using an HTTP call',
        image: {
            primary: '/assets/svg/redesign/nodes/right-panel/httpCall.svg',
        },
        nodeInfoSrc: gitBookBasePath + 'action-nodes/action-nodes-api-integration',
        sortType: '',
        title: 'API Integration',
        nodeType: 'httpCall',
        type: 'action',
    },
    {
        supported_channel: NodeSupportedChannels.ALL,
        canvas: {
            icon: canvasBasePath + 'isEmpty.svg',
            backgroundImg: '/assets/svg/redesign/nodes/action-nodes.svg',
            backgroundImgHover: '/assets/svg/redesign/nodes/action-nodes-hover.svg',
            backgroundImgSelected: '/assets/svg/redesign/nodes/action-nodes-selected.svg',
        },
        count: 0,
        description: 'Check if a variable is Empty',
        image: {
            primary: '/assets/svg/redesign/nodes/right-panel/isEmpty.svg',
        },
        nodeInfoSrc: gitBookBasePath + 'action-nodes/action-nodes-is-empty',
        sortType: '',
        nodeType: 'isEmpty',
        title: 'Is Empty',
        type: 'action',
    },
    {
        supported_channel: NodeSupportedChannels.ALL,
        canvas: {
            icon: canvasBasePath + 'isNull.svg',
            backgroundImg: '/assets/svg/redesign/nodes/action-nodes.svg',
            backgroundImgHover: '/assets/svg/redesign/nodes/action-nodes-hover.svg',
            backgroundImgSelected: '/assets/svg/redesign/nodes/action-nodes-selected.svg',
        },
        count: 0,
        description: 'Check if a variable is Null (non-existent)',
        image: {
            primary: '/assets/svg/redesign/nodes/right-panel/isNull.svg',
        },
        nodeInfoSrc: gitBookBasePath + 'action-nodes/action-nodes-is-null',
        sortType: '',
        nodeType: 'isNull',
        title: 'Is Null',
        type: 'action',
    },
    {
        supported_channel: NodeSupportedChannels.ALL,
        canvas: {
            icon: canvasBasePath + 'math.svg',
            backgroundImg: '/assets/svg/redesign/nodes/action-nodes.svg',
            backgroundImgHover: '/assets/svg/redesign/nodes/action-nodes-hover.svg',
            backgroundImgSelected: '/assets/svg/redesign/nodes/action-nodes-selected.svg',
        },
        count: 0,
        description: 'Do mathematic operations on variables',
        image: {
            primary: '/assets/svg/redesign/nodes/right-panel/math.svg',
        },
        nodeInfoSrc: gitBookBasePath + 'action-nodes/action-nodes-math',
        sortType: '',
        title: 'Calculate',
        nodeType: 'math',
        type: 'action',
    },
    {
        supported_channel: NodeSupportedChannels.ALL,
        canvas: {
            icon: canvasBasePath + 'decimalFormat.svg',
            backgroundImg: '/assets/svg/redesign/nodes/action-nodes.svg',
            backgroundImgHover: '/assets/svg/redesign/nodes/action-nodes-hover.svg',
            backgroundImgSelected: '/assets/svg/redesign/nodes/action-nodes-selected.svg',
        },
        count: 0,
        description: 'Format number inputs to specified pattern',
        image: {
            primary: '/assets/svg/redesign/nodes/right-panel/decimalFormat.svg',
        },
        nodeInfoSrc: gitBookBasePath + 'action-nodes/action-nodes-number-format',
        sortType: '',
        nodeType: 'decimalFormat',
        title: 'Number Format',
        type: 'action',
    },
    {
        supported_channel: NodeSupportedChannels.ALL,
        canvas: {
            icon: canvasBasePath + 'regularExpression.svg',
            backgroundImg: '/assets/svg/redesign/nodes/action-nodes.svg',
            backgroundImgHover: '/assets/svg/redesign/nodes/action-nodes-hover.svg',
            backgroundImgSelected: '/assets/svg/redesign/nodes/action-nodes-selected.svg',
        },
        count: 0,
        description: 'Match variables to regular expression pattern',
        image: {
            primary: '/assets/svg/redesign/nodes/right-panel/regularExpression.svg',
        },
        nodeInfoSrc: gitBookBasePath + 'action-nodes/action-nodes-regular-expression',
        sortType: '',
        nodeType: 'regularExpression',
        title: 'Regular Expression',
        type: 'action',
    },
    {
        supported_channel: NodeSupportedChannels.ALL,
        canvas: {
            icon: canvasBasePath + 'remap.svg',
            backgroundImg: '/assets/svg/redesign/nodes/action-nodes.svg',
            backgroundImgHover: '/assets/svg/redesign/nodes/action-nodes-hover.svg',
            backgroundImgSelected: '/assets/svg/redesign/nodes/action-nodes-selected.svg',
        },
        count: 0,
        description: 'Remap a variable to another variable',
        image: {
            primary: '/assets/svg/redesign/nodes/right-panel/remap.svg',
        },
        nodeInfoSrc: gitBookBasePath + 'action-nodes/action-nodes-remap',
        sortType: '',
        nodeType: 'remap',
        title: 'Remap',
        type: 'action',
    },
    {
        supported_channel: NodeSupportedChannels.ALL,
        canvas: {
            icon: canvasBasePath + 'redis.svg',
            backgroundImg: '/assets/svg/redesign/nodes/action-nodes.svg',
            backgroundImgHover: '/assets/svg/redesign/nodes/action-nodes-hover.svg',
            backgroundImgSelected: '/assets/svg/redesign/nodes/action-nodes-selected.svg',
        },
        count: 0,
        description: 'Interact with Redis data store',
        image: {
            primary: '/assets/svg/redesign/nodes/right-panel/redis.svg',
        },
        nodeInfoSrc: gitBookBasePath + '',
        sortType: '',
        nodeType: 'redis',
        title: 'Temp Storage',
        type: 'action',
        permissions: {
            canEdit: [INTERNAL_ADMIN, INTERNAL_DEVELOPER],
        },
    },
    {
        supported_channel: NodeSupportedChannels.ALL,
        canvas: {
            icon: '/assets/svg/redesign/nodes/canvas-icons/chatHub_canvas_fallback.svg',
            backgroundImg: '/assets/svg/redesign/nodes/chatHub-nodes.svg',
            backgroundImgHover: '/assets/svg/redesign/nodes/chatHub-nodes-hover.svg',
            backgroundImgSelected: '/assets/svg/redesign/nodes/chatHub-nodes-selected.svg',
        },
        count: 0,
        description: '',
        image: {
            primary: '/assets/svg/redesign/nodes/right-panel/chatHub_rsb_fallback.svg',
        },
        nodeInfoSrc: gitBookBasePath + '',
        sortType: '',
        nodeType: 'chatHub',
        title: 'Chat hub',
        type: 'action',
        show: false,
    },
    {
        supported_channel: NodeSupportedChannels.ALL,
        canvas: {
            icon: '/assets/svg/redesign/nodes/canvas-icons/waitForCallback.svg',
            backgroundImg: '/assets/svg/redesign/nodes/action-nodes.svg',
            backgroundImgHover: '/assets/svg/redesign/nodes/action-nodes-hover.svg',
            backgroundImgSelected: '/assets/svg/redesign/nodes/action-nodes-selected.svg',
        },
        count: 0,
        description: 'Wait for a callback before the flow continues',
        image: {
            primary: '/assets/svg/redesign/nodes/right-panel/waitForCallback.svg',
        },
        nodeInfoSrc: gitBookBasePath + 'action-nodes/action-nodes-wait-for-callback',
        sortType: '',
        nodeType: 'waitForCallback',
        title: 'Wait for Callback',
        type: 'action',
    },
    {
        supported_channel: NodeSupportedChannels.ALL,
        canvas: {
            icon: '/assets/svg/redesign/nodes/canvas-icons/variable.svg',
            backgroundImg: '/assets/svg/redesign/nodes/action-nodes.svg',
            backgroundImgHover: '/assets/svg/redesign/nodes/action-nodes-hover.svg',
            backgroundImgSelected: '/assets/svg/redesign/nodes/action-nodes-selected.svg',
        },
        count: 0,
        description: 'Wait for a callback before the flow continues',
        image: {
            primary: '/assets/svg/redesign/nodes/right-panel/variable.svg',
        },
        nodeInfoSrc: gitBookBasePath + 'action-nodes/action-nodes-set-variables',
        sortType: '',
        nodeType: 'setVariable',
        title: 'Set Variables',
        type: 'action',
    },
    {
        supported_channel: NodeSupportedChannels.ALL,
        canvas: {
            icon: '/assets/svg/redesign/nodes/canvas-icons/switchCase.svg',
            backgroundImg: '/assets/svg/redesign/nodes/action-nodes.svg',
            backgroundImgHover: '/assets/svg/redesign/nodes/action-nodes-hover.svg',
            backgroundImgSelected: '/assets/svg/redesign/nodes/action-nodes-selected.svg',
        },
        count: 0,
        description: 'Used to compare variable against several values',
        image: {
            primary: 'assets/svg/redesign/nodes/right-panel/switchCase.svg',
        },
        nodeInfoSrc: gitBookBasePath + 'action-nodes/action-nodes-switch-case',
        sortType: '',
        nodeType: 'switchCase',
        title: 'Switch Case',
        type: 'action',
    },
    {
        supported_channel: NodeSupportedChannels.ALL,
        canvas: {
            icon: '/assets/svg/redesign/nodes/canvas-icons/sendTemplate.svg',
            backgroundImg: '/assets/svg/redesign/nodes/action-nodes.svg',
            backgroundImgHover: '/assets/svg/redesign/nodes/action-nodes-hover.svg',
            backgroundImgSelected: '/assets/svg/redesign/nodes/action-nodes-selected.svg',
        },
        count: 0,
        description: 'Used to send a predefined template message',
        image: {
            primary: 'assets/svg/redesign/nodes/right-panel/sendTemplate.svg',
        },
        nodeInfoSrc: gitBookBasePath + 'action-nodes/action-nodes-send-template',
        sortType: '',
        nodeType: 'sendTemplate',
        title: 'Send Template',
        type: 'action',
    },
    {
        supported_channel: NodeSupportedChannels.ALL,
        canvas: {
            icon: canvasBasePath + 'customTransform.svg',
            backgroundImg: '/assets/svg/redesign/nodes/action-nodes.svg',
            backgroundImgHover: '/assets/svg/redesign/nodes/action-nodes-hover.svg',
            backgroundImgSelected: '/assets/svg/redesign/nodes/action-nodes-selected.svg',
        },
        count: 0,
        description: 'Custom Transform node allows you to run JavaScript code as part of a flow execution to handle complex flows that require advanced computations or data transformations.',
        image: {
            primary: '/assets/svg/redesign/nodes/right-panel/customTransform.svg'
        },
        nodeInfoSrc: gitBookBasePath + 'action-nodes/action-nodes-display-list',
        sortType: '',
        nodeType: 'customTransform',
        title: 'Custom Transform',
        type: 'action',
    },
    {
        supported_channel: NodeSupportedChannels.ALL,
        canvas: {
            icon: '/assets/svg/redesign/nodes/canvas-icons/optOut.svg',
            backgroundImg: '/assets/svg/redesign/nodes/action-nodes.svg',
            backgroundImgHover: '/assets/svg/redesign/nodes/action-nodes-hover.svg',
            backgroundImgSelected: '/assets/svg/redesign/nodes/action-nodes-selected.svg',
        },
        count: 0,
        description: 'Used to opt out user from Broadcast Manager',
        image: {
            primary: 'assets/svg/redesign/nodes/right-panel/optOut.svg'
        },
        nodeInfoSrc: gitBookBasePath + 'action-nodes/action-nodes-opt-out',
        sortType: '',
        nodeType: 'optOut',
        title: 'Opt Out',
        type: 'action',
    },
    {
        supported_channel: NodeSupportedChannels.ALL,
        canvas: {
            icon: '/assets/svg/redesign/nodes/canvas-icons/deleteOptOut.svg',
            backgroundImg: '/assets/svg/redesign/nodes/action-nodes.svg',
            backgroundImgHover: '/assets/svg/redesign/nodes/action-nodes-hover.svg',
            backgroundImgSelected: '/assets/svg/redesign/nodes/action-nodes-selected.svg',
        },
        count: 0,
        description: 'Used to delete a opted-out user from Broadcast Manager',
        image: {
            primary: 'assets/svg/redesign/nodes/right-panel/deleteOptOut.svg'
        },
        nodeInfoSrc: gitBookBasePath + 'action-nodes/action-nodes-delete-opt-out',
        sortType: '',
        nodeType: 'deleteOptOut',
        title: 'Delete Opt Out',
        type: 'action',
    },
    {
        supported_channel: NodeSupportedChannels.ALL,
        canvas: {
            icon: '/assets/svg/redesign/nodes/canvas-icons/optOut.svg',
            backgroundImg: '/assets/svg/redesign/nodes/action-nodes.svg',
            backgroundImgHover: '/assets/svg/redesign/nodes/action-nodes-hover.svg',
            backgroundImgSelected: '/assets/svg/redesign/nodes/action-nodes-selected.svg',
        },
        count: 0,
        description: 'Used to verify if users are opted out from Broadcast Manager',
        image: {
            primary: 'assets/svg/redesign/nodes/right-panel/optOut.svg'
        },
        nodeInfoSrc: gitBookBasePath + 'action-nodes/action-nodes-verify-opt-out',
        sortType: '',
        nodeType: 'verifyOptOut',
        title: 'Verify Opt Out',
        type: 'action',
    }

];

const vendorNodeObjects: NodeObject[] = [
    {
        supported_channel: NodeSupportedChannels.ALL,
        canvas: {
            icon: canvasBasePath + 'vendorVend.svg',
            backgroundImg: '/assets/svg/redesign/nodes/integration-nodes.svg',
            backgroundImgHover: '/assets/svg/redesign/nodes/integration-nodes-hover.svg',
            backgroundImgSelected: '/assets/svg/redesign/nodes/integration-nodes-selected.svg',
        },
        count: 0,
        description: 'Add the required response fields to a CTX vend request for the final step to a vend flow.',
        image: {
            primary: '/assets/svg/redesign/nodes/right-panel/vendorVend.svg',
        },
        nodeInfoSrc: gitBookBasePath + '',
        sortType: '',
        title: 'Vend End Node',
        nodeType: 'vendorVend',
        type: 'integration',
    },
    {
        supported_channel: NodeSupportedChannels.ALL,
        canvas: {
            icon: canvasBasePath + 'vendorLookup.svg',
            backgroundImg: '/assets/svg/redesign/nodes/integration-nodes.svg',
            backgroundImgHover: '/assets/svg/redesign/nodes/integration-nodes-hover.svg',
            backgroundImgSelected: '/assets/svg/redesign/nodes/integration-nodes-selected.svg',
        },
        count: 0,
        description: 'Add the required response fields to a CTX lookup request of a previous vend in a lookup flow.',
        image: {
            primary: '/assets/svg/redesign/nodes/right-panel/vendorLookup.svg',
        },
        nodeInfoSrc: gitBookBasePath + '',
        sortType: '',
        title: 'Lookup End Node',
        nodeType: 'vendorLookup',
        type: 'integration',
    },
    {
        supported_channel: NodeSupportedChannels.ALL,
        canvas: {
            icon: canvasBasePath + 'vendorPing.svg',
            backgroundImg: '/assets/svg/redesign/nodes/integration-nodes.svg',
            backgroundImgHover: '/assets/svg/redesign/nodes/integration-nodes-hover.svg',
            backgroundImgSelected: '/assets/svg/redesign/nodes/integration-nodes-selected.svg',
        },
        count: 0,
        description: 'Add the required response fields to a CTX ping request for a vendor ping flow',
        image: {
            primary: '/assets/svg/redesign/nodes/right-panel/vendorPing.svg',
        },
        nodeInfoSrc: gitBookBasePath + '',
        sortType: '',
        title: 'Ping End Node',
        nodeType: 'vendorPing',
        type: 'integration',
    },
];

const fundingSourceObjects: NodeObject[] = [
    {
        supported_channel: NodeSupportedChannels.ALL,
        canvas: {
            icon: canvasBasePath + 'fundingSourceReserve.svg',
            backgroundImg: '/assets/svg/redesign/nodes/integration-nodes.svg',
            backgroundImgHover: '/assets/svg/redesign/nodes/integration-nodes-hover.svg',
            backgroundImgSelected: '/assets/svg/redesign/nodes/integration-nodes-selected.svg',
        },
        count: 0,
        description: 'Add the required response fields to a .Core funds reservation request in a reserve flow.',
        image: {
            primary: '/assets/svg/redesign/nodes/right-panel/fundingSourceReserve.svg',
        },
        nodeInfoSrc: gitBookBasePath + '',
        sortType: '',
        title: 'Reserve End Node',
        nodeType: 'fundingSourceReserve',
        type: 'integration',
    },
    {
        supported_channel: NodeSupportedChannels.ALL,
        canvas: {
            icon: canvasBasePath + 'fundingSourceConfirm.svg',
            backgroundImg: '/assets/svg/redesign/nodes/integration-nodes.svg',
            backgroundImgHover: '/assets/svg/redesign/nodes/integration-nodes-hover.svg',
            backgroundImgSelected: '/assets/svg/redesign/nodes/integration-nodes-selected.svg',
        },
        count: 0,
        description: 'Add the required response fields to a .Core confirmation of the final status of a transaction in a funding source confirm flow.',
        image: {
            primary: '/assets/svg/redesign/nodes/right-panel/fundingSourceConfirm.svg',
        },
        nodeInfoSrc: gitBookBasePath + '',
        sortType: '',
        title: 'Confirm End Node',
        nodeType: 'fundingSourceConfirm',
        type: 'integration',
    },
];

const integrationsNodeObjects: NodeObject[] = [
    {
        supported_channel: NodeSupportedChannels.ALL,
        canvas: {
            icon: canvasBasePath + 'api.svg',
            backgroundImg: '/assets/svg/redesign/nodes/integration-nodes.svg',
            backgroundImgHover: '/assets/svg/redesign/nodes/integration-nodes-hover.svg',
            backgroundImgSelected: '/assets/svg/redesign/nodes/integration-nodes-selected.svg',
        },
        count: 0,
        description: 'Provides the means to specify the response for the final step to an API flow.',
        image: {
            primary: '/assets/svg/redesign/nodes/right-panel/api.svg',
        },
        nodeInfoSrc: gitBookBasePath + '',
        sortType: '',
        title: 'API End Node',
        nodeType: 'api',
        type: 'integration',
    },
    {
        supported_channel: NodeSupportedChannels.ALL,
        canvas: {
            icon: canvasBasePath + 'nestedNode.svg',
            backgroundImg: '/assets/svg/redesign/nodes/integration-nodes.svg',
            backgroundImgHover: '/assets/svg/redesign/nodes/integration-nodes-hover.svg',
            backgroundImgSelected: '/assets/svg/redesign/nodes/integration-nodes-selected.svg',
        },
        count: 0,
        description: 'Execute a snippet flow in the current flow (by providing a set of input parameters)',
        image: {
            primary: '/assets/svg/redesign/nodes/right-panel/nestedNode.svg',
        },
        nodeInfoSrc: gitBookBasePath + '',
        sortType: '',
        title: 'Nested Node',
        nodeType: 'nestedNode',
        type: 'integration',
        permissions: {
            canEdit: INTERNAL_ALL_ROLES,
        },
    },
    {
        supported_channel: NodeSupportedChannels.ALL,
        canvas: {
            icon: canvasBasePath + 'nested.svg',
            backgroundImg: '/assets/svg/redesign/nodes/integration-nodes.svg',
            backgroundImgHover: '/assets/svg/redesign/nodes/integration-nodes-hover.svg',
            backgroundImgSelected: '/assets/svg/redesign/nodes/integration-nodes-selected.svg',
        },
        count: 0,
        description: 'Enable specific fields to be returned as output to the calling flow in a snippet flow.',
        image: {
            primary: '/assets/svg/redesign/nodes/right-panel/nested.svg',
        },
        nodeInfoSrc: gitBookBasePath + '',
        sortType: '',
        title: 'Nested End Node',
        nodeType: 'nested',
        type: 'integration',
        permissions: {
            canEdit: INTERNAL_ALL_ROLES,
        },
    },
    {
        supported_channel: NodeSupportedChannels.ALL,
        canvas: {
            icon: canvasBasePath + 'nested.svg',
            backgroundImg: '/assets/svg/redesign/nodes/integration-nodes.svg',
            backgroundImgHover: '/assets/svg/redesign/nodes/integration-nodes-hover.svg',
            backgroundImgSelected: '/assets/svg/redesign/nodes/integration-nodes-selected.svg',
        },
        count: 0,
        description: 'End flow',
        image: {
            primary: '/assets/svg/redesign/nodes/right-panel/nested.svg',
        },
        nodeInfoSrc: gitBookBasePath + '',
        sortType: '',
        title: 'End Node',
        nodeType: 'endFlow',
        type: 'integration',
    },
    {
        supported_channel: NodeSupportedChannels.ALL,
        canvas: {
            icon: canvasBasePath + 'nested.svg',
            backgroundImg: '/assets/svg/redesign/nodes/integration-nodes.svg',
            backgroundImgHover: '/assets/svg/redesign/nodes/integration-nodes-hover.svg',
            backgroundImgSelected: '/assets/svg/redesign/nodes/integration-nodes-selected.svg',
        },
        count: 0,
        description: 'Async end node',
        image: {
            primary: '/assets/svg/redesign/nodes/right-panel/nested.svg',
        },
        nodeInfoSrc: gitBookBasePath + '',
        sortType: '',
        title: 'Async End Node',
        nodeType: 'async_api',
        type: 'integration',
        permissions: {
            canEdit: INTERNAL_ALL_ROLES,
        },
    },
];

const startNodeObjects: NodeObject[] = [
    {
        supported_channel: NodeSupportedChannels.ALL,
        canvas: {
            icon: canvasBasePath + 'start.svg',
            backgroundImg: '',
            backgroundImgHover: '',
            backgroundImgSelected: '',
        },
        count: 0,
        description: 'Start of flow',
        image: {
            primary: '/assets/svg/redesign/nodes/right-panel/start.svg',
        },
        nodeInfoSrc: gitBookBasePath + '',
        sortType: '',
        title: 'START',
        nodeType: 'start',
        type: 'start',
    },
    {
        supported_channel: NodeSupportedChannels.ALL,
        canvas: {
            icon: canvasBasePath + 'new.svg',
            backgroundImg: '/assets/svg/new-node-background.svg',
            backgroundImgHover: '/assets/svg/EmptyNode-Readonly-Hover.svg',
            backgroundImgSelected: '/assets/svg/new-node-background-selected.svg',
        },
        count: 0,
        description: 'Deletes current step and creates a new step',
        image: {
            primary: '/assets/svg/redesign/nodes/right-panel/new.svg',
        },
        nodeInfoSrc: gitBookBasePath + '',
        sortType: '',
        title: 'NEW',
        nodeType: 'new',
        type: 'start',
    },
];

export const chatHubErrorObject: NodeObject = {
    type: 'error',
    nodeType: 'chatHub',
    image: {
        primary: '',
    },
    sortType: '',
    count: 0,
    description: '',
    canvas: {
        icon: '',
        backgroundImg: '',
        backgroundImgHover: '',
        backgroundImgSelected: '',
    },
    supported_channel: NodeSupportedChannels.ALL,
    title: '',
    nodeInfoSrc: '',
};

export const nodeTypes: NodeTypes = {
    menuNodes: menuNodeObjects,
    actionNodes: actionNodeObjects,
    integrationsNodes: {
        FUNDING_SOURCE: fundingSourceObjects,
        VENDOR: vendorNodeObjects,
        default: integrationsNodeObjects,
    },
    startNodes: startNodeObjects,
    chathubNodes: [],
};

